var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.selectDeliveryMethod}},[_c('v-list-item-avatar',[_c('v-icon',[_vm._v("mdi-package-variant-closed")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.deliveryMethod.title)+" ")]),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.deliveryMethod.description)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }